import { DateTimeFormat, DateTimeHelper } from '@xemplo/date-time';

const helper = DateTimeHelper.with({
  format: DateTimeFormat.HumanDateMedium,
});

export function pluraliseDays(count: number): string {
  if (count === 1) return '1 day';
  return `${count} days`;
}

export function formatTimeString(time: string | null) {
  if (!time) return '';

  return helper.format(time, {
    format: 'h:mma',
    customInputFormat: 'HH:mm',
  });
}

export function formatDaysBeforePayDay(
  daysBefore: string | null | number,
  time: string | null
): string {
  if (daysBefore === null || daysBefore === undefined) {
    return '-';
  }

  const days = Number(daysBefore);
  const daysText = pluraliseDays(days);

  if (!time) {
    return `${daysText} before pay day`;
  }

  const formattedTime = formatTimeString(time);

  return `${daysText} before pay day by ${formattedTime}`;
}

export function formatDaysAfterPayDay(
  daysAfter: number | null,
  time: string | null = null
): string {
  if (daysAfter === null) {
    return '-';
  }

  const daysText = pluraliseDays(daysAfter);

  if (!time) {
    return `${daysText} after pay day`;
  }

  const formattedTime = formatTimeString(time);

  return `${daysText} after pay day, ${formattedTime}`;
}
